import {useEffect, useState} from 'react';
import {ValidationProcessCompleted} from '..';
import {LinkErrors} from '../../models/User';
import {getBusinessService} from '../../services';
import InvalidLink from './InvalidLink';
import {PreSOP} from './PreSOP';
import {SOP} from './SOP';
import {HeaderImageSOP, HeaderSOP, ValidationMain} from './style';
import {useTranslation} from "react-i18next";
import {VerificationSpinner} from "../../style";
import decodeJWT from "jwt-decode"

export interface BusinessInfo {
  businessName?: string;
  color: string;
  logo?: string;
  callbackUrl?: string;
  username?: string | null;
  htmlSnippet?: string
}

export interface OMToken {
  [key: string]: any;

  iss?: string | undefined;
  sub?: string | undefined;
  aud?: string | string[] | undefined;
  exp: number;
  nbf?: number | undefined;
  iat?: number | undefined;
  jti?: string | undefined;
  businessId: number;
  business: string;
  logo?: string | undefined;
  color?: string | undefined;
  htmlSnippet?: string | undefined;
}


const ValidationProcess = () => {
  const {t} = useTranslation();
  const [businessInfo, setBusinessInfo] = useState<BusinessInfo>({
    color: '#666'
  });
  const [business, setBusiness] = useState<string>('');
  const [operationId, setOperationId] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [operationGuid, setOperationGuid] = useState<string>('');
  const [verificationComplete, setVerificationComplete] = useState<boolean>(false);
  const [startedVerification, setStartedVerification] =
    useState<boolean>(false);
  const [verificationSuccess, setVerificationSuccess] = useState<boolean>(false);
  const [linkError, setLinkError] = useState<LinkErrors>('');
  const [isLoading, setIsLoading] = useState(true);

  let jwt: any =
    window.location.search &&
    window.location.search
      .split('?')[1]
      .split('&')
      .filter((sp) => sp.slice(0, 'jwt'.length) === 'jwt');

  jwt = jwt.length && jwt[0].split('=')[1];

  useEffect(() => {

      const checkJwt = async () => {
        try {
          if (jwt) {
            try {
              const {businessId, exp, callbackUrl, username} = decodeJWT<OMToken>(jwt);
              const expirationTimeInSeconds = exp ? exp * 1000 : 0;
              const now = new Date()
              const isValid = expirationTimeInSeconds >= now.getTime()
              if (isValid) {
                const business = await getBusinessService(businessId, jwt);
                if (business.error) {
                  setLinkError('notexist');
                  setIsLoading(false);
                } else {
                  setBusinessInfo({
                    businessName: business.description,
                    color: business.color ? business.color : "#d2d2d2",
                    logo: business.logo,
                    callbackUrl: business.callbackUrl ? business.callbackUrl : callbackUrl,
                    username: username ? username : null,
                    htmlSnippet: business.htmlSnippet,
                  });
                  setUsername(username ? username : null)
                  setBusiness(businessId.toString());
                  setIsLoading(false);
                }
              } else {
                setLinkError('expired');
                setIsLoading(false);
              }
            } catch (e) {
              setLinkError('notavailable');
              setIsLoading(false);
            }
          }
        } catch
          (e) {
          console.log(e);
        }
      };
      if (jwt) {
        checkJwt();
      }
    }, []
  )
  ;


  const handleComplete = (success: boolean) => {
    setVerificationComplete(true);
    setVerificationSuccess(success);
  }

  const handleSetCustomUsername= (newCustomUsername: string) => {
    setUsername(newCustomUsername);
  }

  const handleSetOperationId= (newOperationId: string) => {
    setOperationId(newOperationId);
  }
  const handleSetOperationGuid= (newOperationGuid: string) => {
    setOperationGuid(newOperationGuid);
  }

  if (isLoading) {
    return <VerificationSpinner/>
  }
  return (
    <ValidationMain data-testid="validationprocess">
      <HeaderSOP color={businessInfo.color}>
        {businessInfo.logo ?
          <HeaderImageSOP className="companyLogoImg" url={`${businessInfo.logo}`}/>
          :
          businessInfo.businessName
            ? <>
              <span className="company-logo">{businessInfo ? businessInfo.businessName : ''}</span>
              <p className="powered">
                Powered by <img src="/assets/img/logo-vu-sm-grey.svg" alt=""/>
              </p>
            </>
            :
            <>
              <span className="company-logo">Webflow</span>
              <p className="powered">
                Powered by <img src="/assets/img/logo-vu-sm-grey.svg" alt=""/>
              </p>
            </>
        }
      </HeaderSOP>

      {linkError ? (
        <InvalidLink error={linkError} color={businessInfo.color}></InvalidLink>
      ) : startedVerification && business ? (
        <>
          <ValidationProcessCompleted
            success={verificationSuccess}
            style={{display: verificationComplete ? 'flex' : 'none'}}
            color={businessInfo.color}
            username={username}
            operationId={operationId}
            operationGuid={operationGuid}
            callbackUrl={businessInfo.callbackUrl}/>
          <SOP
            type={"business"}
            businessId={business}
            customUsername={businessInfo.username}
            handleCustomUsername={handleSetCustomUsername}
            handleOperationId={handleSetOperationId}
            handleOperationGuid={handleSetOperationGuid}
            onComplete={handleComplete}
            style={{display: verificationComplete ? 'none' : 'block'}}
          />
        </>
      ) : (
        <PreSOP
          startVerification={() => setStartedVerification(true)}
          businessName={businessInfo.businessName}
          businessColor={businessInfo.color}
          htmlSnippet={businessInfo.htmlSnippet}
        />
      )}
    </ValidationMain>
  );
};

export default ValidationProcess;
